<div class="tools-container" [formGroup]="toolsFormGroup">
  <h4 class="tools-title">{{ 'PRESENTER.COUNTDOWN_TOOLS.TITLE' | translate }}</h4>

  <mat-form-field>
    <mat-label>{{ 'PRESENTER.COUNTDOWN_TOOLS.TIMEOUT_TEXT' | translate }}</mat-label>
    <input matInput [formControl]="timeoutTextControl" />
  </mat-form-field>

  @if (auctionOvertimeEnabled) {
    <mat-checkbox [formControl]="plusOvertimeLabelControl">
      {{ 'PRESENTER.COUNTDOWN_TOOLS.PLUS_OVERTIME_LABEL' | translate }}
    </mat-checkbox>
  }

  <h4 class="tools-title">{{ 'PRESENTER.COUNTDOWN_TOOLS.END_TIME' | translate }}</h4>
  <mat-button-toggle-group
    [value]="endOnAuctionScheduleCloseControl.value ? 'auction_close' : 'custom_time'"
    (change)="onEndOnAuctionScheduleCloseToggleChange($event.value)"
  >
    <mat-button-toggle value="custom_time">{{ 'PRESENTER.COUNTDOWN_TOOLS.CUSTOM_TIME' | translate }}</mat-button-toggle>
    @if (!auctionScheduledEnd) {
      <span [matTooltip]="'PRESENTER.COUNTDOWN_TOOLS.AUCTION_CLOSE_DISABLED_TOOLTIP' | translate">
        <mat-button-toggle value="auction_close" [disabled]="true">{{
          'PRESENTER.COUNTDOWN_TOOLS.AUCTION_CLOSE' | translate
        }}</mat-button-toggle>
      </span>
    } @else {
      <mat-button-toggle value="auction_close">{{
        'PRESENTER.COUNTDOWN_TOOLS.AUCTION_CLOSE' | translate
      }}</mat-button-toggle>
    }
  </mat-button-toggle-group>

  @if (!endOnAuctionScheduleCloseControl.value) {
    <gb-datetime-form-field
      [formControl]="endControl"
      [timezone]="auctionTimezone"
      [allowPast]="allowPastEndDate"
      dateTranslateKey="PRESENTER.COUNTDOWN_TOOLS.END_DATE"
      timeTranslateKey="PRESENTER.COUNTDOWN_TOOLS.END_TIME"
    ></gb-datetime-form-field>
  }

  @if (endOnAuctionScheduleCloseControl.value && auctionScheduledEnd) {
    <gb-callout color="accent">
      <p
        translate="PRESENTER.COUNTDOWN_TOOLS.AUCTION_SCHEDULED_CLOSE_MESSAGE"
        [translateParams]="{ closing_time: auctionScheduledEnd | date: 'MMM d, y h:mm a' : auctionTimezone }"
      ></p>
    </gb-callout>
  }

  <gb-presenter-tools-advanced-options-container>
    <gb-presenter-tools-text [toolsFormGroup]="toolsFormGroup" [hideFields]="hideFields"></gb-presenter-tools-text>

    <mat-form-field>
      <mat-label>{{ 'PRESENTER.COUNTDOWN_TOOLS.LETTER_SPACING' | translate }}</mat-label>
      <input matInput type="number" [formControl]="letterSpacingControl" min="0" max="20" />
      <span matTextSuffix>{{ 'PX' | translate }}</span>
    </mat-form-field>
  </gb-presenter-tools-advanced-options-container>
</div>
